module.exports = __webpack_public_path__ + "static/img/bank_content01.46f0ee4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank_content01.jpg
// module id = ZRF2
// module chunks = 1